import { Step } from 'react-joyride'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { getFloaterStepStyles, getOverlayStepStyle, TRANSLATION_KEY } from '../utils'
import { DesignTourStepIndex, EditorTourStepIndex } from '../types'
import { useTourConfig } from './useTourConfig'

export const useDesignTourSteps = (): Step[] => {
  const { i18n } = useI18n()
  const { isTablet, isPhone } = useMediaQueries()
  const { toggleTour, toggleDelayedTour, skipTourStep, setAnimationStyles } = useTourConfig()

  const onSkipStep = (stepIndex: DesignTourStepIndex) => {
    trackInternalEvent('skip_rb_onboarding_hint', {
      category: 'design',
      step: stepIndex,
    })
    skipTourStep('design', stepIndex)
  }

  const onClick = (stepIndex: DesignTourStepIndex) => {
    setAnimationStyles()
    trackInternalEvent('see_rb_onboarding_hint', {
      category: 'design',
      step: stepIndex,
    })
    toggleTour({ isRunning: false, isStartModalOpen: false, stepIndex })
    toggleDelayedTour(stepIndex, 'design')
  }

  return [
    {
      offset: 10,
      disableBeacon: true,
      styles: { options: { ...getOverlayStepStyle() } },
      spotlightPadding: 0,
      spotlightClicks: true,
      disableScrolling: true,
      target: '#select-resume-template-button',
      placement: isTablet || isPhone ? 'top' : 'bottom-start',
      title: i18n.t(`${TRANSLATION_KEY}.design.step_1.title`),
      content: i18n.t(`${TRANSLATION_KEY}.design.step_1.content`),
      floaterProps: { styles: { ...getFloaterStepStyles(true) } },
      data: {
        onClick: () => {
          onClick(DesignTourStepIndex.SELECT_TEMPLATE)
        },
      },
    },
    {
      offset: 10,
      disableBeacon: true,
      styles: { options: { ...getOverlayStepStyle(), zIndex: 4 } },
      spotlightPadding: 0,
      spotlightClicks: true,
      showSkipButton: true,
      target: '#resume-templates-container',
      placement: isTablet || isPhone ? 'top' : 'right',
      title: i18n.t(`${TRANSLATION_KEY}.design.step_2.title${isPhone ? '_mobile' : ''}`),
      content: i18n.t(`${TRANSLATION_KEY}.design.step_2.content`),
      floaterProps: { styles: { ...getFloaterStepStyles() } },
      data: {
        onSkip: () => {
          setAnimationStyles()
          onSkipStep(DesignTourStepIndex.SELECT_TEMPLATE)
          toggleDelayedTour(EditorTourStepIndex.EDIT_RESUME, 'editor')
        },
        onClick: () => {},
      },
    },
    {
      offset: 10,
      disableBeacon: true,
      styles: { options: { ...getOverlayStepStyle() } },
      spotlightPadding: 0,
      spotlightClicks: true,
      showSkipButton: true,
      target: '#color-select-2',
      placement: isTablet || isPhone ? 'top' : 'bottom',
      title: i18n.t(`${TRANSLATION_KEY}.design.step_3.title`),
      content: i18n.t(`${TRANSLATION_KEY}.design.step_3.content`),
      floaterProps: { styles: { ...getFloaterStepStyles() } },
      data: {
        onSkip: () => {
          onSkipStep(DesignTourStepIndex.SELECT_COLOR)
          toggleDelayedTour(EditorTourStepIndex.EDIT_RESUME, 'editor')
        },
        onClick: () => {
          toggleTour({ isRunning: false, isStartModalOpen: false, stepIndex: 0 })
          toggleDelayedTour(EditorTourStepIndex.EDIT_RESUME, 'editor')
        },
      },
    },
  ]
}
